export default __webpack_public_path__ + "media/images/council-logo-aded9f7a0a8d4cdd1d9eb14ba9fd3145.png";